import { createStateHook } from 'react-sweet-state';

import { type AISmartButtonState, AISmartButtonStore } from '../../ai-smart-button-store';
/**
 * Hook to access only the context from the AISmartButton state
 */
export const useAIContext = createStateHook(AISmartButtonStore, {
	selector: (state: AISmartButtonState) => state.context,
});

/**
 * Hook to access selected nudges from the AISmartButton state.
 * Uses the nudgesSelector if available, otherwise returns all nudges.
 */
export const useAINudges = createStateHook(AISmartButtonStore, {
	selector: (state: AISmartButtonState) => {
		const { nudges, selectors, context } = state;
		if (selectors?.nudgesSelector) {
			return selectors.nudgesSelector(nudges, context);
		}
		return nudges;
	},
});

/**
 * Hook to access refreshed nudges from the AISmartButton state.
 */
export const useAINudgesRefreshed = createStateHook(AISmartButtonStore, {
	selector: (state: AISmartButtonState) => state.nudgesRefreshed,
});

/**
 * Hook to access selected actions from the AISmartButton state.
 * Uses the actionsSelector if available, otherwise returns all actions.
 */
export const useAIActions = createStateHook(AISmartButtonStore, {
	selector: (state: AISmartButtonState) => {
		const { actions, selectors, context } = state;
		if (selectors?.actionsSelector) {
			return selectors.actionsSelector(actions, context);
		}
		return actions;
	},
});

/**
 * Hook to access surface metadata from the AISmartButton state.
 */
export const useAISurfaceMetadata = createStateHook(AISmartButtonStore, {
	selector: (state: AISmartButtonState) => state.surfaceMetadata,
});

/**
 * Hook to access current view from the AISmartButton state.
 */
export const useAICurrentView = createStateHook(AISmartButtonStore, {
	selector: (state: AISmartButtonState) => state.currentView,
});

/**
 * Hook to access profile data from the AISmartButton state.
 */
export const useAIProfileData = createStateHook(AISmartButtonStore, {
	selector: (state: AISmartButtonState) => state.profileData,
});

/**
 * Hook to access automations config from the AISmartButton state.
 */
export const useAIAutomationsConfig = createStateHook(AISmartButtonStore, {
	selector: (state: AISmartButtonState) => state.automationsConfig,
});

/**
 * Hook to access convo starters enablement from the AISmartButton state.
 */
export const useAIConvoStarters = createStateHook(AISmartButtonStore, {
	selector: (state: AISmartButtonState) => state.showConvoStarters,
});
